import BrandMagnetScoreWarningArray from './brandMagnetScoreWarningArray'
export default BrandMagnetScoreWarningArray
